import { Routes, Route, Navigate } from 'react-router-dom'
import './admin.css'
import { AdminProviders } from './ui'
import AdminLayout from './AdminLayout'
import Overview from './Overview'
import Products from './Products'
import Categories from './Categories'
import Orders from './Orders'
import Customers from './Customers'
import Reviews from './Reviews'
import Banners from './Banners'
import SiteText from './SiteText'
import About from './About'
import Contact from './ContactInfo'
import Header from './HeaderInfo'
import Footer from './FooterInfo'
import Coupons from './Coupons'
import Reports from './Reports'

// Mount once in your router:  <Route path="/admin/*" element={<AdminApp />} />
export default function AdminApp() {
  return (
    <AdminProviders>
      <Routes>
        <Route element={<AdminLayout />}>
          <Route index element={<Reports />} />
          <Route path="products" element={<Products />} />
          <Route path="categories" element={<Categories />} />
          <Route path="orders" element={<Orders />} />
          <Route path="customers" element={<Customers />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="banners" element={<Banners />} />
          <Route path="site-text" element={<SiteText />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="header" element={<Header />} />
          <Route path="footer" element={<Footer />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="overview" element={<Overview />} />
          
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
      </Routes>
    </AdminProviders>
  )
}
